import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import LinearProgress from "@mui/material/LinearProgress";
import CircularProgress from "@mui/material/CircularProgress";

function formatEta(seconds) {
  if (seconds == null || !Number.isFinite(seconds) || seconds < 0) {
    return "Calculating...";
  }
  if (seconds < 60) {
    return `~${Math.max(1, Math.round(seconds))}s remaining`;
  }
  const minutes = Math.floor(seconds / 60);
  const secs = Math.round(seconds % 60);
  return `~${minutes}m ${secs}s remaining`;
}

export default function ScreenshotProgressSnackbar({ open, progress }) {
  const {
    message = "Preparing screenshots...",
    current = 0,
    total = 0,
    etaSeconds = null,
    phase = "capturing",
  } = progress || {};

  const percent =
    total > 0 ? Math.min(100, Math.round((current / total) * 100)) : 0;

  const phaseLabel =
    phase === "zipping"
      ? "Creating zip file"
      : phase === "restoring"
        ? "Restoring current B-scan"
        : phase === "downloading"
          ? "Starting download"
          : "Capturing B-scans";

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      sx={{ maxWidth: 420 }}
    >
      <Paper
        elevation={6}
        sx={{
          width: 380,
          p: 1.5,
          borderRadius: 2,
          border: "1px solid #ce93d8",
          bgcolor: "#f3e5f5",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.25 }}>
          <CircularProgress size={22} thickness={5} sx={{ mt: 0.25, color: "#7b1fa2" }} />
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography
              variant="subtitle2"
              sx={{ fontWeight: 700, color: "#6a1b9a", lineHeight: 1.3 }}
            >
              Screenshot download in progress
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: "#4a148c", mt: 0.25, lineHeight: 1.35 }}
            >
              {message}
            </Typography>
            <Typography
              variant="caption"
              sx={{ color: "#546e7a", display: "block", mt: 0.75 }}
            >
              {phaseLabel}
              {total > 0 ? ` • ${current} / ${total}` : ""}
              {phase === "capturing" ? ` • ${formatEta(etaSeconds)}` : ""}
            </Typography>
            <Box sx={{ mt: 1 }}>
              <LinearProgress
                variant={total > 0 ? "determinate" : "indeterminate"}
                value={percent}
                sx={{
                  height: 6,
                  borderRadius: 3,
                  bgcolor: "#e1bee7",
                  "& .MuiLinearProgress-bar": { bgcolor: "#7b1fa2" },
                }}
              />
            </Box>
          </Box>
        </Box>
      </Paper>
    </Snackbar>
  );
}
